/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PartNumberChangesDetailTrialDisplayModeEnum {
    CREATE = 'Create',
    DETAIL = 'Detail',
    DETAIL_SOLUTION = 'DetailSolution'
}
